var _excluded = ["children", "defaultTheme", "storageKey"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Moon, Sun } from 'lucide-react';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { Button } from "../Button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../Menu/dropdown-menu";
var initialState = {
  theme: 'system',
  setTheme: function setTheme() {
    return null;
  }
};
var ThemeProviderContext = /*#__PURE__*/createContext(initialState);
export function ThemeProvider(_ref) {
  var children = _ref.children,
    _ref$defaultTheme = _ref.defaultTheme,
    defaultTheme = _ref$defaultTheme === void 0 ? 'system' : _ref$defaultTheme,
    _ref$storageKey = _ref.storageKey,
    storageKey = _ref$storageKey === void 0 ? 'vite-ui-theme' : _ref$storageKey,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(function () {
      return localStorage.getItem(storageKey) || defaultTheme;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    theme = _useState2[0],
    _setTheme = _useState2[1];
  useEffect(function () {
    var root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    if (theme === 'system') {
      var systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
      root.classList.add(systemTheme);
      return;
    }
    root.classList.add(theme);
  }, [theme]);
  var value = {
    theme: theme,
    setTheme: function setTheme(theme) {
      localStorage.setItem(storageKey, theme);
      _setTheme(theme);
    }
  };
  return /*#__PURE__*/React.createElement(ThemeProviderContext.Provider, _extends({}, props, {
    value: value
  }), children);
}
export var useTheme = function useTheme() {
  var context = useContext(ThemeProviderContext);
  if (context === undefined) throw new Error('useTheme must be used within a ThemeProvider');
  return context;
};
export function ThemeToggle() {
  var _useTheme = useTheme(),
    setTheme = _useTheme.setTheme;
  return /*#__PURE__*/React.createElement(DropdownMenu, null, /*#__PURE__*/React.createElement(DropdownMenuTrigger, {
    asChild: true
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline",
    size: "sm",
    shape: "square"
  }, /*#__PURE__*/React.createElement(Sun, {
    className: "h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0"
  }), /*#__PURE__*/React.createElement(Moon, {
    className: "absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Toggle theme"))), /*#__PURE__*/React.createElement(DropdownMenuContent, {
    align: "end"
  }, /*#__PURE__*/React.createElement(DropdownMenuItem, {
    onClick: function onClick() {
      return setTheme('light');
    }
  }, "Light"), /*#__PURE__*/React.createElement(DropdownMenuItem, {
    onClick: function onClick() {
      return setTheme('dark');
    }
  }, "Dark"), /*#__PURE__*/React.createElement(DropdownMenuItem, {
    onClick: function onClick() {
      return setTheme('system');
    }
  }, "System")));
}